// @ts-nocheck
import accountCreationFormReducer, {
    AccountCreationFormActions,
} from "@store/Framework/Store/Store/Components/AccountCreationForm/AccountCreationFormReducer";
import userSetupProductSetsReducer, {
    UserSetupProductSetsActions,
} from "@store/Framework/Store/Store/Components/UserSetupProductSets/UserSetupProductSetsReducer";
import { combineReducers } from "redux";

const componentsReducers = combineReducers({
    accountCreationForm: accountCreationFormReducer,
    userSetupProductSets: userSetupProductSetsReducer,
});

export type StoreComponentsActions = AccountCreationFormActions | UserSetupProductSetsActions;

export default componentsReducers;
